export class SaveVendorAccountNotesParametersDto {
    vendorAccountId: number;
    associationVendorId: number; // NOTE: required for all endpoints
    communityId: number;
    newNote: string;
}
